const _excluded = ["name", "value", "label", "required", "onChange", "onBlur", "multiline"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Stack } from '../../Stack';
import { TextField } from '../../TextField';
import { FormikErrorMessage } from '../ErrorMessage';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const FormikTextFieldControl = props => {
  const {
      name,
      value,
      label,
      required,
      onChange,
      onBlur,
      multiline
    } = props,
    formikProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsxs(Stack.Item, {
    children: [/*#__PURE__*/_jsx(TextField, {
      name: name,
      value: value,
      onChange: onChange,
      onBlur: onBlur,
      label: label,
      required: required,
      multiline: multiline
    }), /*#__PURE__*/_jsx(FormikErrorMessage, {
      touched: formikProps.touched,
      errorMessage: formikProps.errorMessage
    })]
  });
};